import { environment } from '../environments/environment';
var ɵ0 = environment.sampleChain.key, ɵ1 = environment.sampleChain.privateKey, ɵ2 = environment.sampleChain.lib, ɵ3 = environment.sampleChain.timeout, ɵ4 = environment.sampleChain.cache, ɵ5 = environment.sampleChain.apiUrl;
var SampleChainConfigModule = /** @class */ (function () {
    function SampleChainConfigModule() {
    }
    return SampleChainConfigModule;
}());
export { SampleChainConfigModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
